import {useEffect, useState} from "react";

export const useHotKey = (keyCodes:Set<string>, callback:()=>void) =>{
    const [keyPressSet,setKeyPressSet] = useState<Set<string>>(new Set<string>());

    const handleKeyDown = (event: KeyboardEvent)=>{
        console.log(`key ${event.key} - code ${event.code}`);
        
        //add key press to keyPressSet if it is one of the input keycode
        if(keyCodes.has(event.code) && !keyPressSet.has(event.code)){
            console.log(`Added ${event.code}`);
            keyPressSet.add(event.code);
        }

        if(keyCodes.size === keyPressSet.size){
            setKeyPressSet(new Set<string>()); 
            callback();
        }
    }


    const handleKeyUp = (event: KeyboardEvent) =>{
        if(keyPressSet.has(event.code)){
            console.log(`Removed ${event.code}`);
            keyPressSet.delete(event.code);
        }
    }

    useEffect(()=>{
        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("keyup",handleKeyUp);
        
        return ()=>{
            window.removeEventListener("keydown",handleKeyDown);
            window.removeEventListener("keyup", handleKeyUp);
        } 
    });
}
